export let archiveDisplayName = "JS6lcd";
export default {archiveDisplayName};